import { interruptAgentApi as generatedApi } from '../generated/conversations/interruptAgent';

import { getConversationApi } from './getConversation';
import { getConversationsApi } from './getConversations';

const interruptAgentApi = generatedApi.enhanceEndpoints({
  endpoints: {
    interruptAgent: {
      onQueryStarted: async ({ conversationId }, { dispatch, queryFulfilled }) => {
        const patchList = dispatch(
          getConversationsApi.util.updateQueryData('getConversations', {}, (draft) => {
            const conversation = draft.data.find((c) => c.id === conversationId);

            if (conversation != null) {
              conversation.manualMode = true;
            }
          }),
        );

        const patchSingle = dispatch(
          getConversationApi.util.updateQueryData('getConversation', { conversationId }, (draft) => {
            draft.data.manualMode = true;
          }),
        );

        try {
          await queryFulfilled;
        } catch {
          patchList.undo();
          patchSingle.undo();
        }
      },
    },
  },
});

export const { useInterruptAgentMutation } = interruptAgentApi;
